export function groupBy(arr, callbackFn) {
    var groups = [];
    arr
        .forEach(function (item) {
        var key = callbackFn(item);
        var group = groups.filter(function (p) { return p.key === key; })[0];
        if (!group) {
            group = {
                key: key,
                items: []
            };
            groups.push(group);
        }
        group.items.push(item);
    });
    return groups;
}
export function flatten(arr, callbackFn) {
    var retArray = [];
    arr
        .forEach(function (item) {
        var items = callbackFn(item);
        retArray.push.apply(retArray, items);
    });
    return retArray;
}
export function sum(arr, callbackFn, initial) {
    var result = initial || 0;
    arr
        .forEach(function (item) {
        result += callbackFn(item);
    });
    return result;
}
export function shuffle(arr) {
    arr = arr.slice(0);
    for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        _a = [arr[j], arr[i]], arr[i] = _a[0], arr[j] = _a[1];
    }
    return arr;
    var _a;
}
export function polyfill() {
    Array.prototype.groupBy = Array.prototype.groupBy || function (callbackFn) { return groupBy(this, callbackFn); };
    Array.prototype.flatten = Array.prototype.flatten || function (callbackFn) { return flatten(this, callbackFn); };
    Array.prototype.sum = Array.prototype.sum || function (callbackFn, initial) { return sum(this, callbackFn, initial); };
    Array.prototype.shuffle = Array.prototype.shuffle || function () { return shuffle(this); };
}



//////////////////
// WEBPACK FOOTER
// ./src/Helpers/Array.ts
// module id = 944
// module chunks = 24